import React, { useCallback, useEffect, useState } from 'react'
import { CButton, CSmartTable } from '@coreui/react-pro'
import moment from 'moment'
import EmailQuotaService from 'src/service/EmailQuotaService'
import ViewMessage from './ViewMessage'
import './GameNotification.css'

// getSentEmailLog joins users, so created_at is ambiguous in ORDER BY and send_time is not a
// column — full_name is the only key it can sort on.
const columns = [
  { label: 'Member', key: 'full_name', filter: false, sorter: true },
  { label: 'Sent', key: 'created_at', filter: false, sorter: false, _style: { width: '16%' } },
  { label: 'Time', key: 'send_time', filter: false, sorter: false, _style: { width: '12%' } },
  { label: 'Message', key: 'show_details', filter: false, sorter: false, _style: { width: '10%' } },
]

const SentMemberEmailLog = () => {
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState()

  const [viewMessageDetails, setViewMessageDetails] = useState('')
  const [modalIsOpen, setIsOpen] = useState(false)

  const fetchUsers = useCallback(() => {
    setLoading(true)
    const offset = itemsPerPage * (activePage - 1)
    const params = new URLSearchParams()
    if (columnSorter?.column) {
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)
    }

    EmailQuotaService.getSentEmailLog(offset, itemsPerPage, activePage, params)
      .then((result) => setUsers(result.data))
      .finally(() => setLoading(false))
  }, [activePage, columnSorter, itemsPerPage])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  const openFromParent = (message) => {
    setViewMessageDetails(message)
    setIsOpen(true)
  }

  return (
    <div className="ge-datatable ge-datatable--no-select ge-datatable--static">
      <CSmartTable
        columns={columns}
        columnSorter={{ external: true }}
        noItemsLabel="No member emails have been sent yet"
        scopedColumns={{
          full_name: (item) => <td className="fw-semibold">{item.full_name || '-'}</td>,
          created_at: (item) => (
            <td>{item.created_at ? moment(item.created_at).format('D.MM.YYYY') : '-'}</td>
          ),
          send_time: (item) => (
            <td>{item.created_at ? moment(item.created_at).format('h:mma') : '-'}</td>
          ),
          show_details: (item) => (
            <td>
              <CButton
                size="sm"
                color="primary"
                variant="outline"
                onClick={() => openFromParent(item.message)}
              >
                View
              </CButton>
            </td>
          ),
        }}
        items={users?.data || []}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{ external: true }}
        paginationProps={{
          activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(page) => setActivePage(page)}
        onItemsPerPageChange={(perPage) => {
          setActivePage(1)
          setItemsPerPage(perPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />

      <ViewMessage
        modalIsOpen={modalIsOpen}
        setIsOpen={setIsOpen}
        viewMessageDetails={viewMessageDetails}
      />
    </div>
  )
}

export default SentMemberEmailLog
